/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import HtmlFile from './HtmlFile/index'
import ImageFile from './ImageFile/index'
import No from './No/index'
import OtherFile from './OtherFile/index'
import PdfFile from './PdfFile/index'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content"
  
}) {
  let isMedia = useIsMedia()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let documentContentTypeValueData = fromData.useDataFormat({ viewPath,
context: 'document',
path: 'content_type',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: documentContentTypeValueData,
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--ox-1-Z1Yf8zk': isMedia.mobile ? "auto" : "hidden"}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ImageFile'}>
<ImageFile
  viewPath={`${viewPath}/ImageFile`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OtherFile'}>
<OtherFile
  viewPath={`${viewPath}/OtherFile`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'HtmlFile'}>
<HtmlFile
  viewPath={`${viewPath}/HtmlFile`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PdfFile'}>
<PdfFile
  viewPath={`${viewPath}/PdfFile`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}